import axios from 'axios';
import React, { useEffect, useState } from 'react';

const Visitors = () => {
  const [totalVisitors, setTotalVisitors] = useState(1000);
  const [displayCount, setDisplayCount] = useState(0);

  // Fetch visitors
  useEffect(() => {
    axios.get('https://api.bakpoket.com/api/Admin/visitors')
      .then(res => {
        let count = res.data.length > 0 ? res.data.length + 1000 : 1000;
        setTotalVisitors(count);
      })
      .catch(() => {});
  }, []);

  // Animation effect
  useEffect(() => {
    if (totalVisitors === 0) return;

    let start = 0;
    const duration = 1000;
    const increment = Math.ceil(totalVisitors / (duration / 16));

    const counter = setInterval(() => {
      start += increment;

      if (start >= totalVisitors) {
        setDisplayCount(totalVisitors);
        clearInterval(counter);
      } else {
        setDisplayCount(start);
      }
    }, 16);

    return () => clearInterval(counter);
  }, [totalVisitors]);

  return (
    <>
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '20px'
      }}
    >
      {/* <div style={{ display: 'flex', gap: '8px' }}>
        {displayCount.toString().split('').map((digit, index) => (
          <div
            key={index}
            style={{
              border: '2px solid #ef4766',
              padding: '2px 6px',
              minWidth: '32px',
              textAlign: 'center',
              backgroundColor: '#fff5f7',
              color: '#ef4766',
              fontWeight: 'bold',
              fontSize: '16px',
              // borderRadius: '6px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
            }}
          >
            {digit}
          </div>
        ))}
      </div> */}
    </div>

    {/* <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '20px'
      }}
    >
      <div style={{ display: 'flex', gap: '8px' }}>
        
          <div
            style={{
              border: '2px solid #ef4766',
              padding: '10px 14px',
              minWidth: '32px',
              textAlign: 'center',
              backgroundColor: '#fff5f7',
              color: '#ef4766',
              fontWeight: 'bold',
              fontSize: '20px',
              // borderRadius: '6px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
            }}
          >
            {displayCount}
          </div>
        
      </div>
    </div> */}
    </>
  );
};

export default Visitors;